<!-- 讲义卡片 -->
<template>
  <div class="card">
    <div class="flag">
      <span>{{ expressType[info.productStatus] }}</span>
      <b>共{{ info.goodsTotle }}本</b>
    </div>
    <p class="course-name">{{ info.productName }}</p>
    <ul class="book-list" v-show="show">
      <li v-for="(item, index) in info.handoutListRespVOS" :key="index" @click="openHand(item, info.productName)">
        <div class="book-name">
          <!-- <span></span> -->
          <b :class="{ active: item.deliveryStatus === 3, red: item.deliveryStatus === 4 }">{{
              deliveryStatus[item.deliveryStatus]
          }}</b>
          <p>{{ item.goodsName }}</p>
        </div>
        <van-icon name="arrow" />
      </li>
    </ul>
    <button class="more" @click="show = !show">
      <span>讲义详情</span>
      <van-icon v-show="!show" name="arrow-down" />
      <van-icon v-show="show" name="arrow-up" />
    </button>
    <HandoutDetail :showDetail="showDetail === 1 ? true : false" :handData="handData" @close="close" />
    <LogisticsDetail :showDetail="showDetail === 2 ? true : false" :deliverData="handData" @close="close" />
  </div>
</template>

<script>
import HandoutDetail from './handoutDetail.vue';
import LogisticsDetail from './logisticsDetail.vue';

export default {
  data() {
    return {
      show: false,
      showDetail: false,
      handData: {},
      expressType: {
        2: '售后中',
        3: '已退货',
        4: '已换货',
      },
      deliveryStatus: {
        1: '待发货',
        2: '已打包',
        3: '已发货',
        4: '不发货',
      },
    };
  },
  props: {
    info: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    HandoutDetail,
    LogisticsDetail,
  },

  computed: {},

  mounted() { },

  created() { },

  methods: {
    openHand(data, productName) {
      this.$emit('setDisabled', true);
      this.showDetail = 1;
      this.handData = Object.assign(data, { productName });
    },
    close(type) {
      if (type === 0) {
        this.$emit('setDisabled', false);
      }
      this.showDetail = type;
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  width: 670px;
  margin: 20px 0 50px 0;
  padding: 0 0 36px 0;
  background: #fff;
  border-radius: 16px;

  .flag {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 0 20px 0;

    span {
      display: inline-block;
      min-width: 76px;
      line-height: 34px;
      color: #fff;
      font-size: 20px;
      text-align: center;
      background: #ccc;
      border-radius: 16px 0 16px 0;
    }

    b {
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      padding: 6px 10px;
      color: #fff;
      font-size: 20px;
      background: #ff6c02;
      border-radius: 0 16px 0 16px;
    }
  }

  .course-name {
    // display: inline-block;
    width: 580px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    color: #333;
    font-weight: 800;
    font-size: 28px;
    line-height: 40px;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin: 0 36px 20px 36px;
  }

  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    background: #fff;
    border: none;

    span {
      padding-right: 5px;
      color: #a5a5a5;
      font-size: 24px;
    }

    ::v-deep .van-icon {
      color: #a5a5a5;
      font-size: 16px;
    }
  }
}

.book-list {
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 36px 36px 36px;
    padding: 20px 0 0 0;
    border-top: 1px solid #f5f5f5;

    .book-name {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 12px;

      span {
        display: inline-block;
        width: 12px;
        height: 12px;
        background: rgba(255, 108, 2, 0.5);
        border-radius: 50%;
      }

      b {
        // margin: 0 16px;
        margin-right: 16px;
        padding: 5px 8px 3px 8px;
        color: #ff6c02;
        font-weight: 400;
        font-size: 24px;
        border: 2px solid #ff6c02;
        border-radius: 8px;
      }

      .active {
        color: #fff;
        background: #ff6c02;
      }

      .red {
        color: #fff;
        background: #ff5d5d;
        border: 1px solid #ff5d5d;
      }

      p {
        width: 400px;
        //  padding: 10px 0;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        line-height: 34px;
        color: #787878;
        font-size: 28px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }

    ::v-deep .van-icon {
      color: #cfcfcf;
      font-size: 16px;
    }
  }
}
</style>
